module.exports = __webpack_public_path__ + "static/img/29.9aaa150c.webp";